<template>
  <footer v-if="show" style="z-index: 999;">
    <div class="footer">
      <div class="block_content">
        <a @click="$parent.goNav('/')" :class="path == '/' ? 'active' :''">
          <div><img alt="" class="" src="/static/image/nav_home.png" /></div>
          首页
        </a>
      </div>
      <div class="block_content">
        <a @click="$parent.goNav('/discount')" :class="path == '/discount' ? 'active' :''">
          <div><img alt="" class="" src="/static/image/nav_promo.png" /></div>
          优惠
        </a>
      </div>
      <div class="block_content">
        <a @click="$parent.goNav('/wallet')" :class="path == '/wallet' ? 'active' :''">
          <div><img alt="" class="" src="/static/image/nav_wallet_a.png" /></div>
          钱包
        </a>
      </div>
      <div class="block_content">
        <a @click="$parent.goNav('/mine')" :class="path == '/mine' ? 'active' :''">
          <div><img alt="" class="" src="/static/image/nav_my.png" /></div>
          我的
        </a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Foot',
  data() {
    return {path:'',show:true};
  },
  methods: {},
  mounted() {},
    watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
       that.path = this.$route.path;
       if(that.path == '/discountInfo' || that.path == '/account'|| that.path == '/addBankCard'|| that.path == '/addUsdtAds'|| that.path == '/bankCard'){
        that.show = false;
       }else{
        that.show = true;

       }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-611499bd.2ebefcf0.css';
</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue